import { createFileRoute } from "@tanstack/react-router";
import { LibrarySettingsPanel } from "../components/settings/LibrarySettings";

export const Route = createFileRoute("/_pages/library")({ component: LibrarySettingsPanel });
